export function getCookie(name) {
  if (typeof document === 'undefined') return null;

  const escapedName = name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1');
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${escapedName}=([^;]*)`),
  );

  return match ? decodeURIComponent(match[1]) : null;
}

export function setCookie(name, value, days = 365) {
  if (typeof document === 'undefined') return;

  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  document.cookie = [
    `${name}=${encodeURIComponent(value)}`,
    `expires=${expires.toUTCString()}`,
    'path=/',
    'SameSite=Lax',
  ].join('; ');
}

export function hasSeenTooltip(cookieKey) {
  return getCookie(cookieKey) === '1';
}

export function markTooltipSeen(cookieKey, days = 365) {
  setCookie(cookieKey, '1', days);
}
